export default {
    data: () => ({
        translations: {
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            },
            addAllStoresText: {
                el: "Σίγουρα θελεις να προσθέσεις το προϊόν ",
                en: "Are you sure you want to add ",
                it: "È sicuro di voler aggiungere "
            },
            addAllStoresText2: {
                el: " σε όλα τα καταστήματα?",
                en: " to all stores?",
                it: " a tutti i negozi?"
            },
            removeFromAllStoresText: {
                el: "Σίγουρα θελεις να αφαιρέσεις το προϊόν ",
                en: "Are you sure you want to remove ",
                it: "È sicuro di voler rimuovere "
            },
            removeFromAllStoresText2: {
                el: " από όλα τα καταστήματα?",
                en: " from all stores?",
                it: " da tutti i negozi?"
            },
            addStoreText: {
                el: "Σίγουρα θελεις να προσθέσεις το προϊόν ",
                en: "Are you sure you want to add ",
                it: "È sicuro di voler aggiungere "
            },
            removeStoreText: {
                el: "Σίγουρα θελεις να αφαιρέσεις το προϊόν ",
                en: "Are you sure you want to remove ",
                it: "Siete sicuri di voler rimuovere "
            },
            to: {
                el: " στο ",
                en: " to ",
                it: " a "
            },
            from: {
                el: " από ",
                en: " from ",
                it: " da "
            },
            checkboxDialogTitle: {
                el: "Προειδοποίηση Αποθήκευσης Αλλαγών",
                en: "Save Changes Alert",
                it: "Avviso di Salvataggio delle Modifiche"
            },
            products: {
                el: " Προϊόντα ",
                en: " Products ",
                it: " Prodotti "
            },
            stores: {
                el: " Καταστήματα ",
                en: " Stores ",
                it: " Negozi "
            },
            searchProducts: {
                el: " Αναζήτηση Προϊόντων ",
                en: " Search Products ",
                it: " Ricerca Prodotti  "
            },
            searchStores: {
                el: " Αναζήτηση Καταστημάτων",
                en: " Search Stores ",
                it: " Ricerca Negozi "
            },
        }
    })
};
